import actionTypes from '../constants/action-types';

const setRedirects = (redirects) => ({
  type: actionTypes.SET_REDIRECTS,
  payload: {
    redirects,
  },
});

export default setRedirects;
